export default {
  editForm: {
    message:
      'Один пуш-канал объединяет приложения для платформ iOS и Андроид. Объедините приложения в канал и отправляйте пуши пользователям этих приложений в одной рассылке. Интегрируйте каждое приложение канала с edna Pulse.',
    label: 'Внутреннее название канала',
    nameHint:
      'Введите внутреннее название канала. Это название используется при настройке каскадов и рассылок.',
  },
};
